/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { Box } from '@apia/theme';
import {
  TResponsiveTableRowRenderer,
  TResponsiveTableRowRendererProps,
} from '../types';

const NoMemoDefaultRowRenderer: TResponsiveTableRowRenderer = React.forwardRef<
  HTMLTableRowElement,
  TResponsiveTableRowRendererProps
>(({ row, rowIndex, ...props }, currentRef) => (
  <Box
    as={'tr' as any}
    sx={useMemo(
      () => ({
        '&.colored, & > *': {
          color: row.color,
          background: row.background,
        },
      }),
      [row.background, row.color],
    )}
    ref={currentRef as React.RefObject<HTMLTableRowElement>}
    data-test-id={props.id}
    {...props}
  />
));

NoMemoDefaultRowRenderer.displayName = 'DefaultRowRenderer';

export const DefaultRowRenderer = NoMemoDefaultRowRenderer;
